export default __webpack_public_path__ + "static/media/TTSHlogo.e709561c.png";